<script>
import Layout from '@layouts/anonymous'
import { changePasswordMethods, toasterMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  page: {
    meta: [{ name: 'description', content: 'Forgotpassword' }],
  },
  components: { Layout },
  data() {
    return {
      autherror: '',
      tokenID: '',
      titleHeader: '',
      alertMessage: '',
      showAlert: false,
      passwordChangeTooltip: constant.passwordChangeTooltip,
      errorConfirmPassword: constant.passwordConfirmation,
      userid: '',
      newpassword: '',
      confirmpassword: '',
      message: '',
      captcha: '',
      emailError: '',
      securityQueError: '',
      captchaError: '',
      showPass: false,
      showPasscon: false,
      confirmaCaptchaError: false,
      fieldDisable: false,
      refreshIcon: true,
      showSpinner: true,
      enableUserNameCheck: true,
      userIdExist: false,
      questionBankOptions: [],
      selectedQ1: '',
      selectedQ2: '',
      selectedQ3: '',
      answer1: '',
      answer2: '',
      answer3: '',
    }
  },
  computed: {
    placeholders() {
      return {
        newpassword: constant.newPassword,
        confirmpassword: constant.confirmPassword,
      }
    },
  },
  mounted() {
    this.getActivateAccountTokenValidOrNot()
    this.refreshCaptha()
    // this.securityQuestions()
    this.userid = ''
  },
  methods: {
    ...changePasswordMethods,
    ...toasterMethods,

    forgotPassword() {
      let isCaptchaValid = this.fieldDisable
      this.$validator.validateAll().then((result) => {
        if (result && isCaptchaValid & !this.userIdExist) {
          this.showSpinner = true
          return this.activateUserAccount({
            userName: this.userid,
            password: this.newpassword,
            tokenId: this.tokenId,
            userAccountActivationQuestionViewModels: [
              {
                securityQuestionID: this.selectedQ1,
                securityAnswer: this.answer1,
              },
              {
                securityQuestionID: this.selectedQ2,
                securityAnswer: this.answer2,
              },
              {
                securityQuestionID: this.selectedQ3,
                securityAnswer: this.answer3,
              },
            ],
          }).then((response) => {
            this.showSpinner = false
            if (response !== undefined || null) {
              this.$router.push({ path: '/accountsuccessfully' })
            } else {
              this.$router.push({
                name: 'errorpage',
                params: {
                  headerMessage: constant.accountHeaderMessage,
                  resultmessage: response.data.message,
                },
              })
            }
          })
        }
      })
    },
    renderNewString(len) {
      let text = ' '
      let chars =
        'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'

      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }

      return text
    },
    refreshCaptha() {
      let message = this.renderNewString(6)
      this.message = message
    },
    capchaVlaidation(e) {
      if (e.trim() === '') {
        this.confirmaCaptchaError = false
      } else if (e.trim() !== '') {
        if (this.message.trim() === e.trim()) {
          this.confirmaCaptchaError = false
          this.refreshIcon = false
          this.fieldDisable = true
        } else {
          this.confirmaCaptchaError = true
        }
      }
    },

    getActivateAccountTokenValidOrNot() {
      this.showSpinner = true
      this.tokenId = this.$route.params.tokenid
      return this.fetchAccountTokenIsValid({
        token: this.tokenId,
      })
        .then((response) => {
          this.showSpinner = false
          if (response !== undefined || null) {
            if (response.data.id === 0) {
              this.$router.push({
                name: 'errorpage',
                params: {
                  headerMessage: constant.accountHeaderMessage,
                  resultmessage: response.data.message,
                },
              })
            } else if (response.data.securityquestions.length > 0) {
              this.questionBankOptions = response.data.securityquestions.map(
                (qa) => {
                  return {
                    value: qa.securityQuestionID,
                    text: qa.securityQuestion,
                  }
                }
              )
            }
          } else {
            this.$router.push({
              name: 'errorpage',
              params: {
                headerMessage: constant.accountHeaderMessage,
                resultmessage: constant.errorMessage,
              },
            })
          }
        })
        .catch((error) => {
          this.showSpinner = false
          this.showAlert = true
          this.autherror = error
          this.alertMessage = constant.errorMessage
        })
    },
    onUserNameChange() {
      this.enableUserNameCheck = true
    },
    checkUserNameExists() {
      if (this.enableUserNameCheck && this.userid !== '') {
        this.showSpinner = true
        return this.isUserNameExists({
          username: this.userid,
        })
          .then((response) => {
            this.showSpinner = false
            this.enableUserNameCheck = false
            this.userIdExist = response
          })
          .catch((error) => {
            this.showSpinner = false
            this.authError = error
          })
      }
    },
    confirmClicked() {
      this.showAlert = false
    },
    showhideNew() {
      this.showPass = !this.showPass
    },
    showhideconfirm() {
      this.showPasscon = !this.showPasscon
    },
    async securityQuestions() {
      try {
        this.showSpinner = true
        const allQuestions = await this.getSecurityQuestions()
        if (allQuestions.status === 200 && allQuestions.data.length > 0) {
          this.questionBankOptions = allQuestions.data.map((qa) => {
            return { value: qa.securityQuestionID, text: qa.securityQuestion }
          })
        } else {
          this.setAlert({
            title: constant.imageHeaderError,
            msg: 'API response not received',
            variant: constant.errorMessagetype,
          })
        }
      } catch (error) {
        this.showSpinner = false
        this.authError = error
        this.setAlert({
          title: constant.imageHeaderError,
          msg: constant.errorMessage,
          variant: constant.errorMessagetype,
        })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>

<template>
  <Layout>
    <BaseSpinner v-if="showSpinner" />

    <b-row class="no-gutters" align-v="center" align-h="center">
      <b-col>
        <form
          :class="$style.loginbox"
          class="p-4"
          @submit.prevent="forgotPassword"
        >
          <BaseELabel
            :class="$style.labelHeader"
            class="text-center border-bottom"
            label="Activate Account"
          />
          <BaseELabel
            :class="$style.labelsubheader"
            class="text-center"
            label="Please fill the details below to securely activate the account."
          />
          <b-row>
            <b-col>
              <BaseEInputText
                id="userid"
                v-model="userid"
                v-validate="{ required: true, regex: /^[^@.,';`]+$/ }"
                validattor="[^@.,';`]+$"
                type="text"
                maxlength="20"
                label-content="User ID"
                name="userid"
                mark-required
                data-vv-as="User ID"
                :placeholder="placeholders.userid"
                :class="{
                  input: true,
                  'is-danger': errors.has('userid'),
                }"
                autocomplete="off"
                debounce="500"
                @change="onUserNameChange"
                @blur="checkUserNameExists"
              ></BaseEInputText>
              <div class="mb-1 error">
                {{ errors.first('userid') }}
              </div>
              <div v-if="userIdExist && userid !== ''" class="error">
                User ID already exists!
              </div>
            </b-col>
          </b-row>

          <div class="input-fields" align-h="start">
            <BaseELabel mark-required label="New Password" />
            <div>
              <div class="d-flex">
                <input
                  v-show="!showPass"
                  ref="password"
                  v-model="newpassword"
                  v-b-tooltip.right="
                    'Password must have at least 8 characters and should contain at least: 1 upppercase letter, 1 lowercase letter, 1 number and one of the special symbols !@#$%^&*()'
                  "
                  v-validate="'required|min:8|verify_password'"
                  class="form-control mb-1"
                  :class="$style.input"
                  name="password"
                  type="password"
                  :placeholder="placeholders.newpassword"
                  data-vv-as="Password"
                />
                <input
                  v-show="showPass"
                  ref="password"
                  v-model="newpassword"
                  v-b-tooltip.right="passwordChangeTooltip"
                  v-validate="'required|verify_password'"
                  class="form-control mb-1"
                  :class="$style.input"
                  name="password"
                  type="text"
                  :placeholder="placeholders.newpassword"
                  data-vv-as="Password"
                />
                <span
                  :class="$style.fieldIcon"
                  @click.prevent="showhideNew($event)"
                >
                  <BaseIcon
                    v-show="!showPass"
                    :class="$style.iconColor"
                    name="eye"
                  />
                  <BaseIcon
                    v-show="showPass"
                    :class="$style.iconColor"
                    name="eye-slash"
                  />
                </span>
              </div>
              <div v-show="errors.has('password')" class="error">{{
                errors.first('password')
              }}</div>
            </div>
            <BaseELabel mark-required label="Confirm Password" />
            <div>
              <div class="d-flex">
                <input
                  v-show="!showPasscon"
                  ref="conpass"
                  v-model="confirmpassword"
                  v-validate="'required|confirmed:password'"
                  class="form-control mb-1"
                  :class="$style.input"
                  name="password_confirmation"
                  type="password"
                  :placeholder="placeholders.confirmpassword"
                  data-vv-as="Password"
                />
                <input
                  v-show="showPasscon"
                  ref="conpass"
                  v-model="confirmpassword"
                  v-validate="'required|confirmed:password'"
                  class="form-control mb-1"
                  :class="$style.input"
                  name="password_confirmation"
                  type="text"
                  :placeholder="placeholders.confirmpassword"
                  data-vv-as="Password"
                />
                <span
                  :class="$style.fieldIcon"
                  @click.prevent="showhideconfirm($event)"
                >
                  <BaseIcon
                    v-show="!showPasscon"
                    :class="$style.iconColor"
                    name="eye"
                  />
                  <BaseIcon
                    v-show="showPasscon"
                    :class="$style.iconColor"
                    name="eye-slash"
                  />
                </span>
              </div>
              <div v-if="errors.has('password_confirmation')" class="error">{{
                errorConfirmPassword
              }}</div>
            </div>
          </div>

          <b-row>
            <b-col md="6">
              <BaseELabel mark-required label="Security Question" size="sm" />
              <b-form-select
                v-model="selectedQ1"
                v-validate="'required'"
                name="Security Question 1"
                plain="true"
                :class="$style.selectStyle"
                :options="
                  questionBankOptions.filter(
                    (Qb) => Qb.value !== selectedQ2 && Qb.value !== selectedQ3
                  )
                "
              ></b-form-select>
              <div :class="$style.error">
                {{ errors.first('Security Question 1') }}
              </div>
            </b-col>
            <b-col md="6">
              <BaseEInputText
                id="answer1"
                v-model="answer1"
                v-validate="{ required: true, min: 3, max: 40 }"
                data-vv-as="Answer"
                type="text"
                name="answer1"
                label-content="Answer"
                mark-required
                :class="{
                  input: true,
                  'is-danger': errors.has('answer1'),
                }"
                :placeholder="placeholders.answer1"
              ></BaseEInputText>
              <div :class="$style.error">
                {{ errors.first('answer1') }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <BaseELabel mark-required label="Security Question" size="sm" />
              <b-form-select
                v-model="selectedQ2"
                v-validate="'required'"
                name="Security Question 2"
                plain="true"
                :class="$style.selectStyle"
                :options="
                  questionBankOptions.filter(
                    (Qb) => Qb.value !== selectedQ1 && Qb.value !== selectedQ3
                  )
                "
              ></b-form-select>
              <div :class="$style.error">
                {{ errors.first('Security Question 2') }}
              </div>
            </b-col>
            <b-col md="6">
              <BaseEInputText
                id="answer2"
                v-model="answer2"
                v-validate="{ required: true, min: 3, max: 40 }"
                data-vv-as="Answer"
                type="text"
                name="answer2"
                label-content="Answer"
                mark-required
                :class="{
                  input: true,
                  'is-danger': errors.has('answer2'),
                }"
                :placeholder="placeholders.answer2"
              ></BaseEInputText>
              <div :class="$style.error">
                {{ errors.first('answer2') }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <BaseELabel mark-required label="Security Question" size="sm" />
              <b-form-select
                v-model="selectedQ3"
                v-validate="'required'"
                name="Security Question 3"
                plain="true"
                :class="$style.selectStyle"
                :options="
                  questionBankOptions.filter(
                    (Qb) => Qb.value !== selectedQ1 && Qb.value !== selectedQ2
                  )
                "
              ></b-form-select>
              <div :class="$style.error">
                {{ errors.first('Security Question 3') }}
              </div>
            </b-col>
            <b-col md="6">
              <BaseEInputText
                id="answer3"
                v-model="answer3"
                v-validate="{ required: true, min: 3, max: 40 }"
                data-vv-as="Answer"
                type="text"
                name="answer3"
                label-content="Answer"
                mark-required
                :class="{
                  input: true,
                  'is-danger': errors.has('answer3'),
                }"
                :placeholder="placeholders.answer3"
              >
              </BaseEInputText>
              <div :class="$style.error">
                {{ errors.first('answer3') }}
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <BaseELabel
                for="captcha"
                mark-required
                label="For security, enter text shown in the image"
              />
            </b-col>
            <b-col md="6">
              <BaseCaptcha
                v-model="message"
                :message="message"
                name="message"
                :refresh-icon="refreshIcon"
                :disabled="fieldDisable"
                @refreshCaptha="refreshCaptha"
              />
            </b-col>

            <b-col md="6">
              <BaseEInputText
                v-model="captcha"
                v-validate="'required'"
                field-id="captchaAns"
                name="captcha"
                label-content
                :is-disabled="fieldDisable"
                @keyup="capchaVlaidation(captcha)"
              />

              <div v-show="errors.has('captcha')" class="error"
                >Text is required</div
              >
              <div v-if="confirmaCaptchaError" class="error"
                >Entered Text is invalid</div
              >
            </b-col>
          </b-row>
          <b-row class="my-3">
            <!-- <b-col>
              <BaseButton :class="$style.btnHover" @click="$router.go(-1)"
                >CANCEL</BaseButton
              >
            </b-col> -->
            <b-col>
              <BaseEButton type="submit" :class="$style.btnHover"
                >Activate</BaseEButton
              >
            </b-col>
          </b-row>
        </form>
      </b-col>
    </b-row>
    <BaseModalAlert
      :modal-show="showAlert"
      :title-header="titleHeader"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    ></BaseModalAlert>
  </Layout>
</template>
<style lang="scss" module>
@import '@design';
.input {
  display: block;
  width: 100%;
  margin-bottom: $size-grid-padding;
  background-color: $color-content-bg;
  border: $size-input-border solid $color-input-border;
  border-radius: $size-input-border-radius;
}
.fieldIcon {
  position: relative;
  z-index: 2;
  float: right;
  margin-top: 9px;
  margin-left: -25px;
}
.iconColor {
  width: $size-input-padding-horizontal !important;
  color: $color-link-text;
}
.loginbox {
  width: 550px;
  padding: 30px;
  margin: 0 auto;
  background: #fcfcfc;
  border-radius: 3px;
  -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.05),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
}
.labelHeader {
  padding-bottom: 15px;
  margin-bottom: 0.5rem;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.2;
  line-height: 2rem;
  color: #1e3866;
}
.labelsubheader {
  margin-bottom: $size-content-margin;
  font-weight: Normal;
  color: #878787;
}
.btnHover:hover {
  color: $color-text-white;
  background-color: #5a6268 !important;
  border-color: #545b62 !important;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
</style>
